"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showLoaderToast = exports.showToast = exports.Toaster = void 0;
const react_1 = __importDefault(require("react"));
const react_hot_toast_1 = __importStar(require("react-hot-toast"));
const constants_1 = __importDefault(require("@/constants"));
const __1 = require("..");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Toaster = (props) => react_1.default.createElement(react_hot_toast_1.Toaster, Object.assign({ toastOptions: { className: styles_scss_1.default.toast } }, props));
exports.Toaster = Toaster;
const showToast = (title, message, ToastOptions) => {
    const toastId = react_hot_toast_1.default(react_1.default.createElement("div", { className: styles_scss_1.default.toastContent },
        react_1.default.createElement("div", { className: styles_scss_1.default.toastContentText },
            react_1.default.createElement("label", { htmlFor: "#" }, title),
            react_1.default.createElement("small", null, message)),
        react_1.default.createElement("div", { className: styles_scss_1.default.toastContentButton, "aria-hidden": "true", onClick: () => react_hot_toast_1.default.dismiss(toastId) }, "Ok")), Object.assign({ position: 'bottom-left', duration: 5000 }, ToastOptions));
};
exports.showToast = showToast;
const showLoaderToast = (ToastOptions) => {
    const toastId = react_hot_toast_1.default(react_1.default.createElement("div", { className: styles_scss_1.default.loaderToastContent },
        react_1.default.createElement(__1.CircularLoader, { width: "22px", height: "22px", thickness: "2px", color: styles_scss_1.default.secondary }),
        react_1.default.createElement("div", { className: styles_scss_1.default.loaderToastContentText },
            react_1.default.createElement("small", null, constants_1.default.general.loading2))), Object.assign({ position: 'bottom-left', duration: Infinity }, ToastOptions));
    return toastId;
};
exports.showLoaderToast = showLoaderToast;
